import styles from './PlayButton.module.scss';

export type PlayButtonProps = {
  fillColor?: 'white' | 'black';
  size?: number;
};
export default function PlayButton({
  fillColor = 'white',
  size = 32
}: PlayButtonProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={styles.playIconSvg}
    >
      <path
        d="M1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16Z"
        stroke={fillColor}
        strokeWidth="2"
      />
      <circle opacity="0.2" cx="16" cy="16" r="14" fill="#17171A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7915 11.332V20.6654L20.5832 15.9987L12.7915 11.332Z"
        fill={fillColor}
      />
    </svg>
  );
}
